import { useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import CalendarNavDay from "../../../components/CalendarNav/CalendarNavDay";
import CalendarNavMonth from "../../../components/CalendarNav/CalendarNavMonth";
import LimitPerPage from "../../../components/LimitPerPage/LimitPerPage";
import NumberCard from "../../../components/NumberCard/NumberCard";
import Pagination from "../../../components/Pagination/Pagination";
import useModal from "../../../hooks/useModal";
import { useStore } from "../../../store/useStore";
import { INFRACTION_DATE_TYPES, JOURNEY_CONTROL_TYPES } from "../../../utils/constants/constants";
import JourneyOverviewTable from "./JourneyOverviewTable";
import DraggableRangeAreaChart from "../../../components/DraggableRangeAreaChart/DraggableRangeAreaChart";

const JourneyControlGeneral: React.FC<{}> = () => {
  const { pushModal } = useModal();
  const getJourneyOverview = useStore((state) => state.journeyControl.getJourneyOverview);
  const getInfractionTypePerPeriodChartData = useStore((state) => state.infraction.getInfractionTypePerPeriodChartData);
  const journeyOverview = useStore((state) => state.journeyControl.journeyOverview);
  const infractionsSummarized: any = useStore((state) => state.infraction.infractionsSummarized);
  const infractionsTypePerPeriodChartData = useStore((state) => state.infraction.infractionsTypePerPeriodChartData);
  const isLoadingJourneyOverview = useStore((state) => state.journeyControl.isLoadingJourneyOverview);
  const isLoadingInfractionsTypePerPeriodChartData = useStore((state) => state.infraction.isLoadingInfractionsTypePerPeriodChartData);
  const filters = useStore((state) => state.infraction.infractionRankingList.filters);
  const selectedDateType = useStore((state) => state.infraction.selectedDateType);
  const yesterday = new Date();
  
  yesterday.setDate(yesterday.getDate() - 1);

  useEffect(() => {
    getJourneyOverview();
    getInfractionTypePerPeriodChartData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="flex justify-center shadow-box mt-4">
        <CalendarNavDay
          date={filters.start_date ? new Date(filters.start_date) : yesterday}
          show={selectedDateType === INFRACTION_DATE_TYPES[0].value}
        />
      </div>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-4 lg:grid-cols-4 gap-3">
        {
          JOURNEY_CONTROL_TYPES.map(({label, value, field} : { label: string, value: string, field: unknown }) => {
            const { total } = infractionsSummarized[0]?.find((item: any) => item.type === value) || { total: 0 };
            const { total: lastTotal } = infractionsSummarized[1]?.find((item: any) => item.type === value) || { total: 0 };

            const difference = (total ?? 0) - (lastTotal ?? 0);
            const percentageDifference = lastTotal !== 0 ? ((difference / lastTotal) * 100) : null;

            return (
              <NumberCard 
                title={label}
                value={parseFloat(total.toFixed(2)).toString() ?? '-'}
                percentageDifference={percentageDifference}
                color="#C7CCD0"
                loading={isLoadingInfractionsTypePerPeriodChartData}
              />
            )
          })
        }
      </div>
      <div className="my-4 w-full">
        <div className="shadow-base rounded-[8px] bg-white mt-3 px-10 py-5">
          <div className="text-dark-blue font-bold text-2xl mb-5">Panorama de Jornadas</div>
          <div>
            <JourneyOverviewTable />
          </div>
          <div className="flex justify-between items-center">
            <div className="text-gray_1">
              Mostrando{" "}
              {!isLoadingJourneyOverview ? (journeyOverview.data.length + journeyOverview.offset * journeyOverview.limitPerPage) : <Skeleton inline width={20} />}{" "}
              de {journeyOverview.totalItems} registros
            </div>
            <div className="flex gap-5 items-center">
              <LimitPerPage
                onLimitChange={(e: any) =>
                  journeyOverview.setLimitPerPage(e.target.value)
                }
              />
              <Pagination
                currentPage={journeyOverview.currentPage}
                totalPages={journeyOverview.totalPages}
                onPageChange={journeyOverview.setCurrentPage}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between">
        <div className="shadow-base rounded-[8px] bg-white mt-3 px-10 py-5 w-[49%]">
          <DraggableRangeAreaChart
            title={"Aderência nos últimos meses"}
            data={infractionsTypePerPeriodChartData}
            loading={isLoadingInfractionsTypePerPeriodChartData}
            div='chartdiv'
            height={selectedDateType === INFRACTION_DATE_TYPES[0].value ? 450 : 300}
          />
        </div>
        <div className="shadow-base rounded-[8px] bg-white mt-3 px-10 pt-5 w-[50%]">
          Gráfico 2
        </div>
      </div>
      
    </>
  );
};

export default JourneyControlGeneral;
